<script setup lang="ts">
import NewsListing from '~/components/news/listing/NewsListing.vue'

const { t } = useI18n()

useHead({
  title: t('pages.news.listing.header.title'),
})

useFancyHeader()

false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    en: '/news/[tag]/[tag_id]',
    sk: '/novinky/[tag]/[tag_id]',
  },
})
</script>

<template>
  <NewsListing />
</template>
